<template>
  <div class="drop--card--info__container">
    <div v-if="icon !== null" class="drop--card--info__icon">
        <i :class="icon"></i>
    </div>
    <div class="drop--card--info__text">
        <span v-if="text !== null" >{{ text }}</span>
      </div>
  </div>
</template>

<script>
export default {
  name: 'DropCardInfo',
  props: {
    text: { type: String, default: null },
    icon: { type: String, default: null }
  }
}
</script>

<style lang="scss" scoped>

</style>
